import * as React from "react";
import { Button, Grid } from "components/controls/widget";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import YesNoDialog, { YesNoDialogProps } from "common/components/controls/YesNoDialog"
import Error from "common/components/controls/Error";
import apiOznameniPrestupu, { OznData } from "common/api/SendEmailNotifications/OznameniPrestupu";
import PrestupyUtils from "common/utils/PrestupyUtils";
import { Prestup, PotvrzeniPrestupu as apiPotvrzeniPrestupu, ZamitnutiPrestupu as apiZamitnutiPrestupu } from "common/api/Evidence/Clenove/Prestupy";

interface PotvrzeniICProps {
    prestup: Prestup;
    je_to_clen: boolean;
    setPrestup: (prestup: Prestup) => void;
}


interface State {
    showDialogPotvrzeni: boolean;
    showDialogZamitnuti: boolean;
    submitting?: boolean;
    hasError: boolean;
    error?: React.ReactNode;
}

type Props = PotvrzeniICProps & State & ActionsExecutorPropsType;


const initialState: State = {
    showDialogPotvrzeni: false,
    showDialogZamitnuti: false,
    hasError: false,
}


class PotvrzeniIC extends React.PureComponent<Props & WithStyles<typeof styles>>{

    handleClose = (potvrzeni: boolean, cancel: boolean) => {
        if (cancel) {
            this.showDialog(potvrzeni, false);
        } else {
            const { executeAction, prestup } = this.props
            const action1 = potvrzeni ? apiPotvrzeniPrestupu(prestup.id) : apiZamitnutiPrestupu(prestup.id);
            action1
                .onSuccess(p => {
                    const action2 = apiOznameniPrestupu()
                        .onSuccess(() => this.close(potvrzeni, p))
                        .onError(() => this.close(potvrzeni, p));
                    executeAction(action2, {}, { prestupId: p.id, typZpravy: PrestupyUtils.TypZpravy_PotvrzeniIC })
                })
                .onValidationFailed(e => this.setError(e['_error']))
                .onError(e => this.setError(e.message));

            executeAction(action1, { submitting: true, hasError: false, error: undefined });
        }
    }

    setError = (error: string | string[]) => {
        this.props.updateState({ submitting: false, hasError: true, error: error });
    }

    showDialog = (potvrzeni: boolean, show: boolean) => {
        if (potvrzeni === true) {
            if (this.props.showDialogPotvrzeni !== show) {
                this.props.updateState({ submitting: false, showDialogPotvrzeni: show, hasError: false, error: undefined });
            }

        } else {
            if (this.props.showDialogZamitnuti !== show) {
                this.props.updateState({ submitting: false, showDialogZamitnuti: show, hasError: false, error: undefined });
            }
        }
    }

    close = (potvrzeni: boolean, prestup: Prestup) => {
        this.showDialog(potvrzeni, false);
        this.props.setPrestup(prestup);
    }


    render() {
        const { prestup, je_to_clen, showDialogPotvrzeni, showDialogZamitnuti, hasError, error, submitting, classes } = this.props;

        const dlgPropsPotvrzeni: YesNoDialogProps = {
            show: showDialogPotvrzeni,
            submitting: submitting,
            handleClose: cancel => this.handleClose(true, cancel),
            title: 'Potvrzení přestupu',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const dlgPropsZamitnuti: YesNoDialogProps = {
            show: showDialogZamitnuti,
            submitting: submitting,
            handleClose: cancel => this.handleClose(false, cancel),
            title: 'Zamítnutí přestupu',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const zobrazit = (je_to_clen && prestup.stav === PrestupyUtils.Stav_PotvrzeniIC);


        return zobrazit ? <div className={classes.root}>
            <Grid container justify="space-between" direction="row" spacing={8}>
                <Grid item xs={3}>
                    <Button color="success" variant="contained" onClick={() => this.showDialog(true, true)}>{'Potvrdit přestup'}</Button>
                </Grid>
                <Grid item xs={3}>
                    <Button color="danger" variant="contained" onClick={() => this.showDialog(false, true)}>{'Zamítnout přestup'}</Button>
                </Grid>
                <Grid item xs={6} />
            </Grid>
            <YesNoDialog {...dlgPropsPotvrzeni}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu potvrzujete přestup?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
            <YesNoDialog {...dlgPropsZamitnuti}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu chcete zamítnout přestup?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
        </div> : null;
    }
}



export const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(withActionsExecutor<PotvrzeniICProps, State>(initialState, PotvrzeniIC));
